import { gql } from '@apollo/client';
export const DOCUMENTATION_DOSSIER_FIELDS = gql `
  fragment DocumentationDossierFields on DossierDto {
    id
    name
    businessUnitId
    dossierTemplate {
      id
      name
      code
    }
    participants {
      id
      name
    }
  }
`;
export const DocumentationDossierFields = {
    fragment: DOCUMENTATION_DOSSIER_FIELDS,
    fragmentName: 'DocumentationDossierFields',
};
